const webConfig = {
    defaultIcon : "/img/logo/defaultLogo.jpg",
    defaultAvatar : "/img/user_null.png",
    logo: "/img/logo_TinViet.jpg",
    defaultBanner: "/img/logo/defaultLogo.jpg",
    defaultQrCode: '/img/defaultQrCode.png',
    getCurrency : (price) => {
        return new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND',currencyDisplay: 'code' }).format(price);
    },
}

export default webConfig;